import { render, staticRenderFns } from "./CheckinFooter.vue?vue&type=template&id=279da081&scoped=true"
import script from "./CheckinFooter.vue?vue&type=script&lang=js"
export * from "./CheckinFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279da081",
  null
  
)

export default component.exports